export interface UtilizationMethod {
  title: string;
  body: string;
}

export const utilizationIntro =
  "Every method below is included at no additional cost. Mix and match them to fit your rollout.";

export const utilizationMethods: readonly UtilizationMethod[] = [
  {
    title: "Custom Bridgework in Courses",
    body: "All courses include bridgework between live sessions. We can customize it, like adding a video from one of your senior leaders. Development fees may apply if Looking Forward Consulting builds the learning assets.",
  },
  {
    title: "Personalized Invitations",
    body: "Development Pros follow up one-on-one with every learner, based on the courses in their Development Plan or Learning Path.",
  },
  {
    title: "Success Stories and Case Studies",
    body: "Feature an article or video about a learner and how they turned the learning into measurable results.",
  },
  {
    title: "Short, Impactful Previews",
    body: "Short videos on what a course covers and why to take it. Hooks that drive enrollment.",
  },
  {
    title: "Recognition and Small Incentives",
    body: "Learners earn points for completing events, then redeem them for stickers, keychains, and pins. Branded prizes can be added.",
  },
  {
    title: "Connect It to Career Growth",
    body: "Map every course to your competency model. We can build learning paths for any role, site, group, or the whole organization, tied to lines of progression.",
  },
  {
    title: "Watch Party: Leader-led Sessions",
    body: "A supervisor attends a session with the whole team, live or recorded. We supply discussion questions, prep the leader, and track attendance.",
  },
  {
    title: "Executive Support Videos",
    body: "Short videos from your senior leaders reinforcing key content, played as bridgework at the start of selected courses.",
  },
  {
    title: "Showcase Metrics",
    body: "Highlight engagement by site or group to create healthy internal competition and visible momentum.",
  },
  {
    title: "ROI Analysis",
    body: "Looking Forward Consulting has three certified ROI specialists and can run a full ROI analysis.",
  },
  {
    title: "Course Spotlights",
    body: "Highlight specific courses on internal networks, using key influencers to talk about what makes them valuable.",
  },
  {
    title: "Leader Roundtables",
    body: "Record roundtable discussions, video or podcast-style, and embed them into the course structure as bridgework.",
  },
  {
    title: "Messages to Supervisors and Managers",
    body: "The Development Pro engages supervisors directly to discuss team needs and build custom learning paths that close skill gaps.",
  },
  {
    title: "Instructor Office Hours",
    body: "Instructors host weekly open office hours where participants drop in for personalized support.",
  },
];

export interface UtilizationStack {
  title: string;
  body: string;
  tags: readonly string[];
}

export const utilizationStacks: readonly UtilizationStack[] = [
  {
    title: "New Manager Launch",
    body: "Onboard first-time managers with executive-recorded bridgework, team watch parties, and weekly office hours.",
    tags: ["Custom Bridgework", "Watch Party", "Office Hours"],
  },
  {
    title: "Enterprise Rollout",
    body: "Anchor to your competency model, invite learners one-to-one, and publish site-by-site engagement dashboards.",
    tags: ["Career Growth Mapping", "Personalized Invitations", "Showcase Metrics"],
  },
  {
    title: "Prove the Business Case",
    body: "Combine learner case studies, a certified ROI study, and internal spotlights into executive-ready proof.",
    tags: ["Success Stories", "ROI Analysis", "Course Spotlights"],
  },
];
